import React, { useContext } from 'react';
import classnames from 'classnames';
import IconButton from 'components/IconButton';
import { CONSTANTS } from 'common/ListKeyboardNav';
import { HorizontalMoreButtonItemContext } from './HorizontalMoreButtonItem';

const { LIST_ITEM_TABABLE_ITEM } = CONSTANTS;

const HorizontalMoreButtonItemIconContext = React.createContext<any>({});

export interface HorizontalMoreButtonItemIconProps extends React.ComponentPropsWithRef<'button'> {
  /**  children, Icon Component to place in IconButton */
  children: React.ReactNode;
  /** To configure the size of the `HorizontalMoreButtonItemIcon`. */
  size?: 'small' | 'medium';
}

/** All other props will be provided to IconButton. */
const HorizontalMoreButtonItemIcon = React.forwardRef<HTMLElement, HorizontalMoreButtonItemIconProps>((props: HorizontalMoreButtonItemIconProps, ref) => {
  const {
    children,
    size,
    ...otherProps
  } = props;

  const classes = classnames({
    [LIST_ITEM_TABABLE_ITEM]: true
  });

  const { size: inheritedSize } = useContext(HorizontalMoreButtonItemContext);
  const resolvedSize = inheritedSize || size;

  return (
    <HorizontalMoreButtonItemIconContext.Provider value={{ size: resolvedSize }}>
      <IconButton
        ref={ref}
        className={classes}
        tabIndex={-1}
        {...otherProps}
      >
        {children}
      </IconButton>
    </HorizontalMoreButtonItemIconContext.Provider>
  );
});

HorizontalMoreButtonItemIcon.displayName = 'HorizontalMoreButtonItemIcon';

HorizontalMoreButtonItemIcon.defaultProps = {
  size: 'medium'
};

export {
  HorizontalMoreButtonItemIcon as default,
  HorizontalMoreButtonItemIconContext
};
